<mat-form-field class="w-100">
   <mat-label>{{label}}</mat-label>
   <input type="time" matInput [formControl]="formControl" [matAutocomplete]="auto" [min]="'00:00'">
   <mat-autocomplete #auto="matAutocomplete" (opened)="autoCompleteOpened()">
      <mat-option *ngFor="let option of filteredOptions" [value]="option.value" (click)="writeValue(option)">
         {{option.label}}
      </mat-option>
   </mat-autocomplete>
   <app-input-error [formControlItem]="formControl"></app-input-error>
</mat-form-field>
